export default {
  name: 'collapseTransition',
  functional: true,
  props: {
    second: {
      type: Number,
      default: 0.5,
    },
  },
  render(h, ctx) {
    return h(
      'transition',
      {
        props: {
          name: 'collapseTransition',
        },
        on: {
          beforeEnter(el) {
            el.style.height = 0
          },
          enter(el) {
            el.style.transition = `height ${ctx.props.second}s ease-in-out`
            el.style.height = el.scrollHeight + 'px'
            el.style.overflow = 'hidden'
          },
          afterEnter(el) {
            el.style.transition = ''
            el.style.height = ''
            el.style.overflow = 'visible'
          },
          beforeLeave(el) {
            el.style.height = el.scrollHeight + 'px'
          },
          leave(el) {
            el.style.transition = `height ${ctx.props.second}s ease-in-out`
            setTimeout(() => {
              el.style.height = '0px'
            })
            el.style.overflow = 'hidden'
          },
          afterLeave(el) {
            el.style.transition = ''
            el.style.height = ''
          },
        },
      },
      ctx.children
    )
  },
}
